import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import styles from './ProjectsWidget.module.css';
import { Card, CardContent, CardHeader, CardTitle } from "../../../_newprofiles/components/ui/Card";
import { Wrench, Plus } from "lucide-react";
import axios from 'axios';
import api from '../../../api/api.js';
import AddEditProjectModal from '../../Projects/components/AddEditProjectModal';
import { API_BASE_URL } from '../../../config';
import showToast from '../../../components/ShowToast';

const ProjectsWidget = ({ homeUserId }) => {
  const [projects, setProjects] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const fetchProjects = async () => {
    if (!homeUserId) return;
    setIsLoading(true);
    setError(null);
    try {
      const response = await api.get(`/api/Projects/getmyprojects?homeUserId=${homeUserId}`);
      setProjects(response.data);
    } catch (err) {
      setError("Failed to load projects.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (homeUserId) {
      fetchProjects();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [homeUserId]);

  const handleSaveProject = async (projectData) => {
    const token = localStorage.getItem('token');
    if (!token) {
      showToast('error', 'You must be logged in to save a project.');
      return;
    }

    if (!homeUserId) {
      showToast('error', 'Could not identify user. Please log in again.');
      return;
    }

    const projectPayload = {
      ...projectData,
      homeUserId: homeUserId,
      status: "Planning",
      jobs: [],
    };

    try {
      await api.post('/api/Projects', projectPayload);
      showToast('success', 'Project created successfully!');
      fetchProjects(); // Refresh the list
    } catch (error) {
      showToast('error', 'Failed to create project.');
      console.error("Error creating project:", error);
    }
    
    setIsModalOpen(false);
  };

  return (
    <Card className={styles.cardBase}>
      <CardHeader>
        <div className={styles.projectsHeader}>
          <CardTitle className={styles.cardTitleContainer}>
            <Wrench className={`${styles.cardTitleIcon} ${styles.cardTitleIconBlue}`} />
            <span>Your Projects</span>
          </CardTitle>
          <Link to="/projects" className={styles.viewAllButton}>
            Manage All Projects
          </Link>
        </div>
      </CardHeader>
      <CardContent>
        <button onClick={() => setIsModalOpen(true)} className={styles.addProjectButton}>
          <Plus size={16} /> Add New Project
        </button>
        {isLoading && <p>Loading projects...</p>}
        {error && <p className={styles.errorText}>{error}</p>}
        {!isLoading && !error && projects.length === 0 && (
          <p>You haven't created any projects yet.</p>
        )}
        {!isLoading && !error && projects.length > 0 && (
          <div className={styles.projectsList}>
            {projects.slice(0, 3).map(project => (
              <Link to={`/project/${project.projectId}`} key={project.projectId} className={styles.projectItemLink}>
                <div className={styles.projectItem}>
                  <h4 className={styles.projectTitle}>{project.name}</h4>
                  <span className={styles.projectStatus}>{project.status}</span>
                </div>
              </Link>
            ))}
          </div>
        )}
      </CardContent>
      <AddEditProjectModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSave={handleSaveProject}
      />
    </Card>
  );
};

export default ProjectsWidget;
